import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!

  return (_openBlock(), _createBlock(_component_v_chip, {
    variant: "outlined",
    size: "x-small",
    color: "default",
    title: "title"
  }, {
    default: _withCtx(() => [
      _createElementVNode("strong", null, _toDisplayString(_ctx.count), 1)
    ]),
    _: 1
  }))
}